import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../../api/ApiRoutes";
import createRegulatorPortalInstance from "../../../api/RegulatorPortalInstance";
import { parseComplianceVerifyJob } from "./parseComplianceVerify";
import { COMPLIANCE_RESULTS_LIST_QUERY_KEY } from "./useComplianceResultsList";
import { PROMOTABLE_SERVICES_QUERY_KEY } from "./usePromotableServices";
import type { ComplianceVerifyJob } from "./types";

export const approveRunningServices =
  async (): Promise<ComplianceVerifyJob | null> => {
    const response = await createRegulatorPortalInstance().post(
      API_ROUTES.REGULATOR_COMPLIANCE_APPROVE_RUNNING,
      {},
    );
    return parseComplianceVerifyJob(response.data);
  };

export const useApproveRunningServices = (): UseMutationResult<
  ComplianceVerifyJob | null,
  Error,
  void
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["regulator-portal", "approve-running"],
    mutationFn: approveRunningServices,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PROMOTABLE_SERVICES_QUERY_KEY,
      });
      queryClient.invalidateQueries({
        queryKey: COMPLIANCE_RESULTS_LIST_QUERY_KEY,
      });
    },
  });
};
